export const ROUTES = {
  ROUTE_FILES: 'organization-types-type-boxes-box-files',
  ROUTE_FILES_NODE: 'organization-types-type-boxes-box-files-node',
  ROUTE_QUEUE: 'organization-types-type-boxes-box-inbox',
  ROUTE_TRASH: 'organization-types-type-boxes-box-trash',
  ROUTE_TRASH_NODE: 'organization-types-type-boxes-box-trash-node',
  ROUTE_SEARCH: 'organization-types-type-boxes-box-search',
}
